import { PayloadTransactionSummary } from "../types";

export function getTransactionsTotal(transactions: PayloadTransactionSummary[] | undefined) {
  if (!transactions) return 0
  return transactions.reduce((sum, t) => sum + (t.amount), 0)
}
